import { resetTableView } from "../features/plan-table-view.js";
import { render } from "../features/views.js";
import { runtime } from "./runtime.js";
import { t } from "./i18n.js";

export function toast(msg, options = {}) {
  const el = document.getElementById("toast");
  el.replaceChildren(document.createTextNode(t(msg)));
  el.classList.toggle("has-action", !!options.action);
  if (options.action) {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "toast-action";
    button.textContent = options.action;
    if (options.shortcut) {
      const kbd = document.createElement("kbd");
      kbd.textContent = options.shortcut;
      button.append(kbd);
    }
    button.onclick = options.onAction;
    el.append(button);
  }
  el.classList.add("show");
  const duration = options.duration || 2200;
  const schedule = () => {
    clearTimeout(toast.t);
    toast.t = setTimeout(hideToast, duration);
  };
  // Keep an actionable toast open while the pointer rests on it.
  el.onmouseenter = options.action ? () => clearTimeout(toast.t) : null;
  el.onmouseleave = options.action ? schedule : null;
  schedule();
}

export function hideToast() {
  clearTimeout(toast.t);
  const el = document.getElementById("toast");
  el.classList.remove("show");
  el.onmouseenter = el.onmouseleave = null;
}

export function navigate(delta) {
  if (runtime.page === "table") return;
  runtime.selectedDate.setDate(runtime.selectedDate.getDate() + delta);
  render();
}

export function goToday() {
  runtime.selectedDate = new Date();
  runtime.selectedDate.setHours(12, 0, 0, 0);
  runtime.page = "today";
  render();
}

export function setPage(p) {
  if (p === "table") resetTableView();
  runtime.page = p;
  render();
  window.scrollTo({ top: 0, behavior: "smooth" });
}
